import React, { useState, useEffect, useMemo } from 'react';

import RoomItemSearchResult from '../RoomItemSearchResult/RoomItemSearchResult';
import Pagination from '../../Pagination';
import Spinner from '../../UI/Spinner/Spinner';
import { ROOM_SEARCH_LIMIT } from '../../../constans/pagination';
import { setPaginState, uniqueBy } from '../../../helpers/helper-methods';
import SearchService from '../../../services/search.service';
import styles from './SearchResultRoomsList.module.scss';
import RoomsService from '../../../services/rooms.service';

const SearchResultRoomsList = ({
  requestId,
  propertyId,
  onRoomOffersClick,
  detailsView,
}) => {
  const searchService = useMemo(() => SearchService(), []);
  const roomsService = useMemo(() => RoomsService(), []);
  const [roomsList, setRoomsList] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [total, setTotal] = useState(0);
  const [nextOffsetPage, setNextOffsetPage] = useState(0);

  const roomDataHandler = (data = [], pagination) => {
    if (!data.length) return;

    setPaginState(
      uniqueBy(data, (object1, object2) => object1?.title === object2?.title),
      pagination,
      0,
      setRoomsList,
      setPageNumber,
      setTotal,
      setNextOffsetPage,
    );
  };

  const getRooms = async ({ selected: page }) => {
    if (detailsView) {
      roomsService.getRoomsByPropertyId({
        propertyId,
        limit: ROOM_SEARCH_LIMIT,
        offset: page * ROOM_SEARCH_LIMIT,
      }).then(({ data, pagination }) => {
        roomDataHandler(data, pagination);
      });

      return;
    }

    if (propertyId && requestId) {
      searchService.getPropertyRoomsByUUID(propertyId, requestId, page)
        .then(({ data, pagination }) => {
          roomDataHandler(data, pagination);
        });
    }
  };

  useEffect(() => {
    if (detailsView) {
      roomsService.getRoomsByPropertyId({
        propertyId,
        limit: ROOM_SEARCH_LIMIT,
        offset: 0,
      }).then(({ data, pagination }) => roomDataHandler(data, pagination));
    } else if (propertyId && requestId) {
      searchService.getPropertyRoomsByUUID(propertyId, requestId, 0)
        .then(({ data, pagination }) => {
          roomDataHandler(data, pagination);
        });
    }
  }, [propertyId, requestId]);

  return (
    <div>
      {roomsList ? (
        <>
          <div className={styles.list}>
            {roomsList && roomsList.map((roomItem, index) => (
              <RoomItemSearchResult
                detailsView={detailsView}
                key={`sd12gfl${index}`}
                offerIndex={index + 1}
                id={roomItem.id}
                currencyCode={roomItem.currencyCode}
                onRoomOffersClick={onRoomOffersClick}
                bedTypes={roomItem.bedTypes}
                capacitiesObj={roomItem.capacitiesObj}
                itemStyles={styles.roomItem}
                title={roomItem.title}
                description={roomItem.description}
                amenities={roomItem.amenities}
                photos={roomItem.photos}
                surface={roomItem.surface}
                pvRate={(parseFloat(roomItem?.PV))?.toFixed(2)}
                offerPerPrice={roomItem.pricePerNight}
                offerTotalPrice={roomItem.totalPrice}
              />
            ))}
          </div>
          <Pagination
            perPage={ROOM_SEARCH_LIMIT}
            forcePage={pageNumber}
            total={total}
            callback={getRooms}
          />
        </>
      ) : <Spinner spinnerClasses="spinner-primary" />}
    </div>
  );
};

export default SearchResultRoomsList;
